import React, { FC, useEffect, useRef, useState } from "react";
import { TagProps } from "./Tags.types";
import "./Tags.scss";
import closeButtonTabs from "../Icon/svgs/closeSmall.svg";
import addWhite from "../Icon/svgs/add-alteon-white.svg";
import addGray from "../Icon/svgs/add-alteon-gray.svg";

export const TagInput: FC<TagProps> = ({
  tagType = "tag",
  tags,
  addLabel,
  placeHolder,
  filled,
  updateTags,
  childClass,
  tagClasses,
  label,
  children,
  maxTagAllowed,
  disableTag,
  datatestIdForAddTagBtn,
  saveOnLeave = false
}) => {
  const [tagData, setTagData] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setTagData(tags);
  }, [tags]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [isAdding]);
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        isAdding &&
        inputRef.current &&
        !inputRef.current.contains(e.target)
      ) {
        if (saveOnLeave) {
          addTagData();
        }
        setIsAdding(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isAdding]);
  const onKeyUp = (key) => {
    if (key === "Enter") {
      addTagData();
    } else if (key === "Escape") {
      setIsAdding(false);
    } else {
      return null;
    }
  };
  const removeTagData = (indexToRemove) => {
    const newTags = [...tagData.filter((_, index) => index !== indexToRemove)];

    setTagData(newTags);

    if (updateTags) {
      updateTags(newTags);
    }
  };

  const addTagData = () => {
    const newTag = inputRef.current.value.trim();
    const duplicateTag = tagData.includes(newTag);
    if (newTag !== "" && !duplicateTag) {
      const newTags = [...tagData, newTag];

      setTagData(newTags);

      if (updateTags) {
        updateTags(newTags);
      }

      inputRef.current.value = "";

      setIsAdding(false);
      setError(null);
    } else if (duplicateTag) {
      setError(`${newTag} already exists`);
    }
  };
  const addTagToggle = () => {
    setIsAdding(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const addClassesActive = filled
    ? `alteon-add-tag-filled ${tagClasses?.listLabelClassName}`
    : `alteon-add-tag-unfilled ${tagClasses?.listLabelClassName}`;

  const addClassesInactive = filled
    ? `alteon-add-tag-unfilled-inactive ${tagClasses?.listLabelClassName} ${
        disableTag && "tag-disabled"
      }`
    : `alteon-add-tag-unfilled-inactive ${tagClasses?.listLabelClassName} ${
        disableTag && "tag-disabled"
      }`;

  const tagListClasses =
    filled === false && tagType === "list"
      ? `alteon-tag-unfilled-list ${tagClasses?.labelClassName}`
      : `alteon-tag-filled-list ${tagClasses?.labelClassName}`;

  const tagListLabelClass =
    tagType === "list" ? "tags-label-text-list" : "tags-label-text";
  return (
    <div className={`alteon-tag-input ${tagClasses?.tagInputClass}`}>
      <div className={`${tagListLabelClass} ${tagClasses?.labelClassName}`}>
        <span>{label ? label : null}</span>
      </div>
      <ul className={`alteon-tags-${tagType} ${tagClasses?.tagsItemWrapper}`}>
        {tagData.length > 0 &&
          tagData.map((tag, index) => (
            <li
              key={index}
              className={
                tagType === "list"
                  ? tagListClasses
                  : `alteon-tag-filled ${tagClasses?.listLabelClassName} ${
                      disableTag && "tag-disabled"
                    }`
              }
            >
              <span className="alteon-tag-title">{tag}</span>
              <div className={`${childClass}`}>{children}</div>
              {tagType === "list" ? (
                ""
              ) : (
                <img
                  onClick={() => removeTagData(index)}
                  className={`alteon-tags-close-icon`}
                  src={`${closeButtonTabs}`}
                />
              )}
            </li>
          ))}
        {maxTagAllowed !== tagData.length && (
          <li
            onClick={() => setIsAdding(true)}
            className={isAdding ? addClassesActive : addClassesInactive}
            data-testid={datatestIdForAddTagBtn}
          >
            {isAdding ? (
              // <span onClick={() => setIsAdding(true)}>
              <img
                onClick={() => setIsAdding(true)}
                className={`alteon-tags-add-icon-active-input`}
                src={`${addWhite}`}
              />
            ) : (
              // </span>
              // Gray
              <img className={`alteon-tags-add-icon`} src={`${addGray}`} />
            )}
            <span className="alteon-tag-title" onClick={() => addTagToggle()}>
              {isAdding ? (
                <input
                  className="alteon-add-tag-input"
                  type="tags"
                  onClick={() => addTagToggle()}
                  onKeyUp={(event) => onKeyUp(event.key)}
                  placeholder={placeHolder}
                  ref={inputRef}
                  data-testid="tag-input"
                  style={{ border: "none" }}
                />
              ) : (
                addLabel
              )}
            </span>
          </li>
        )}
        {error && (
          <li className={`tag-error ${tagClasses?.errorClass}`}>{error}</li>
        )}
      </ul>
    </div>
  );
};
